import MainCameraView from './MainCameraView';

export default MainCameraView;
